import React from "react";
import { Route, Switch } from 'react-router-dom';
import classNames from "classnames";
import jMoment from "moment-jalaali";

import Dashboard from "../../containers/Dashboard";
import Channels from "../../containers/Channels";
import ChannelPage from "../../containers/Channels/ChannelPage";
import AnalysisReports from "../../containers/AnalysisReports";
import HomeSettings from "../../containers/HomeSettings";
import MediumHomeSettings from "../../containers/HomeSettings/Mediums";
import Ads from "../../containers/Ads";
import AppSettings from "../../containers/AppSettings";

import styles from "./Main.module.scss";

export default props => {
  jMoment.loadPersian({
    dialect: "persian-modern",
    usePersianDigits: true
  });
  return (
    <div className={classNames(styles.main, 'pt-3 pb-3')}>
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/reports/analysis" component={AnalysisReports} />
        <Route exact path="/channels" component={Channels} />
        <Route exact path="/channels/new" component={ChannelPage} />
        <Route exact path="/channels/:id" component={ChannelPage} />
        <Route exact path="/layout" component={HomeSettings} />
        <Route exact path="/layout/mediums" component={MediumHomeSettings} />
        <Route exact path="/app-setting" component={AppSettings} />
        <Route path="/ads" component={Ads} />
      </Switch>
    </div>
  )
}